import type { ReactNode } from 'react';
import { Button, Flex, Typography } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  extra?: ReactNode;
  onBack?: boolean | (() => void);
}

/** antd v5 dropped `PageHeader` from core — this is the minimal replacement every page uses. */
export function PageHeader({ title, subtitle, extra, onBack }: PageHeaderProps) {
  const navigate = useNavigate();
  const handleBack = onBack === true ? () => navigate(-1) : onBack || undefined;

  return (
    <Flex
      align="flex-start"
      justify="space-between"
      gap={12}
      wrap="wrap"
      style={{ marginBottom: 16 }}
    >
      <Flex align="center" gap={8}>
        {handleBack ? (
          <Button type="text" aria-label="back" icon={<ArrowLeftOutlined />} onClick={handleBack} />
        ) : null}
        <div>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {title}
          </Typography.Title>
          {subtitle ? <Typography.Text type="secondary">{subtitle}</Typography.Text> : null}
        </div>
      </Flex>
      {extra ? <Flex gap={8}>{extra}</Flex> : null}
    </Flex>
  );
}
